/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WorkstreamNarrativeUrlAdminResponse } from '../models/WorkstreamNarrativeUrlAdminResponse';
import type { WorkstreamNarrativeUrlAdminUpdate } from '../models/WorkstreamNarrativeUrlAdminUpdate';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NarrativeUrlsService {

    /**
     * List Admin Narrative Urls
     * The period's pillars, then every other workstream under its narrative
     * root that has a narrative link.
     * @param timeframe Planning period label (e.g. H1 FY26, H2 FY26).
     * @returns WorkstreamNarrativeUrlAdminResponse Successful Response
     * @throws ApiError
     */
    public static listAdminNarrativeUrlsApiV1AdminWorkstreamNarrativeUrlsGet(
        timeframe?: (string | null),
    ): CancelablePromise<Array<WorkstreamNarrativeUrlAdminResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/workstream/narrative-urls',
            query: {
                'timeframe': timeframe,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Admin Narrative Url
     * Set or clear one workstream's narrative link.
     * @param workstreamId
     * @param requestBody
     * @param timeframe Planning period the admin page is showing.
     * @returns WorkstreamNarrativeUrlAdminResponse Successful Response
     * @throws ApiError
     */
    public static updateAdminNarrativeUrlApiV1AdminWorkstreamWorkstreamIdNarrativeUrlPut(
        workstreamId: number,
        requestBody: WorkstreamNarrativeUrlAdminUpdate,
        timeframe?: (string | null),
    ): CancelablePromise<WorkstreamNarrativeUrlAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/workstream/{workstream_id}/narrative-url',
            path: {
                'workstream_id': workstreamId,
            },
            query: {
                'timeframe': timeframe,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
